<template>
  <dialog-form
    :show-dialog="isShowDialog"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="updateLocationName"
  >
    <template #title>
      Update Location Name
    </template>

    <div class="field-group">
      <label class="control-label"> Location Name* </label>
      <sanitized-input
        id="locationName"
        v-model="locationName"
        placeholder="Ex. Pharmacy"
        required
      />
    </div>

    <template #submit-button>
      Confirm
    </template>
  </dialog-form>
</template>

<script setup lang="ts">
import { ref } from 'vue';

defineProps({
  isShowDialog: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submit', 'cancel']);

const locationName = ref('');

const dialogOpen = () => {
  locationName.value = '';
};

const updateLocationName = () => {
  emit('submit', locationName.value);
};

const hideDialog = () => {
  emit('cancel');
};
</script>
